import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import React from "react";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { useCallback } from 'react';
import { connectMenu } from 'react-instantsearch-dom';
import { useIntl } from 'react-intl';
import { Chevron } from 'theme/icons';
import { Container } from './SelectFilter.style';

var MenuSelect = function MenuSelect(_ref) {
  var items = _ref.items,
      currentRefinement = _ref.currentRefinement,
      refine = _ref.refine,
      fieldLabelIdPrefix = _ref.fieldLabelIdPrefix,
      icons = _ref.icons;
  var intl = useIntl();
  var handleChange = useCallback(function (filter) {
    return refine(filter);
  }, [refine]);
  var orderedItems = items.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      translatedLabel: intl.formatMessage({
        id: "".concat(fieldLabelIdPrefix, ".options.").concat(item.label)
      })
    });
  });
  orderedItems.sort(function (a, b) {
    return a.translatedLabel.localeCompare(b.translatedLabel);
  });
  return __jsx(Container, null, __jsx(FormControl, {
    variant: "outlined",
    fullWidth: true
  }, __jsx(InputLabel, null, intl.formatMessage({
    id: "".concat(fieldLabelIdPrefix, ".name")
  })), __jsx(Select, {
    onChange: function onChange(event) {
      return handleChange(event.target.value);
    },
    value: currentRefinement === null ? '' : currentRefinement,
    defaultValue: currentRefinement === null ? '' : currentRefinement,
    label: intl.formatMessage({
      id: "".concat(fieldLabelIdPrefix, ".name")
    }),
    IconComponent: Chevron
  }, __jsx(MenuItem, {
    value: "",
    key: "".concat(fieldLabelIdPrefix, ".options.empty")
  }, intl.formatMessage({
    id: "".concat(fieldLabelIdPrefix, ".options.empty")
  })), orderedItems.map(function (_ref2) {
    var label = _ref2.label,
        value = _ref2.value,
        translatedLabel = _ref2.translatedLabel;
    return __jsx(MenuItem, {
      key: value,
      value: value === '' ? currentRefinement : value
    }, (icons === null || icons === void 0 ? void 0 : icons[label]) !== undefined && icons[label], translatedLabel);
  }))));
};

var SelectFilter = connectMenu(MenuSelect);
export default SelectFilter;